import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { getUserInfo } from "../../redux/SecureKey/getUserAction";
import "./callback.css";
import * as rk from "../../localization/resourceKeys";
import i18n from "../../i18n";
import { useHistory } from "react-router";
import { loadRequestSelectorSuccess } from "../../redux/RequestSelector/requestSelectorActions";
import { loadStateSelectorSuccess } from "../../redux/StateSelector/stateSelectorActions";
import PropTypes from "prop-types";

const Callback = ({ getUserInfo, secureKey, networkErrorState, loadRequestSelectorSuccess, loadStateSelectorSuccess, updateLanguage }) => {
  const history = useHistory();
  const [error, setError] = useState(false);
  const [networkError, setNetworkError] = useState(false);
  const [authenticationError, setAuthenticationError] = useState(false);
  useEffect(() => {
    const queryParameters = new URLSearchParams(window.location.search);
    const secureKeyCode = queryParameters.get("code");
    const currentUrl = window.location.protocol + "//" + window.location.host;
    getUserInfo({
      secureKeyCode: secureKeyCode,
      callbackRouteName: "callback",
      currentSiteUrl:
        currentUrl === process.env.REACT_APP_AUDI_QC_PRIVACY_PORTAL
          ? process.env.REACT_APP_AUDI_QC_PRIVACY_PORTAL
          : process.env.REACT_APP_VW_QC_PRIVACY_PORTAL,
      verificationType: "SUBMIT_REQUEST"
    });
  }, [getUserInfo, history]);

  const handleClose = () => {
    setNetworkError(false);
    setAuthenticationError(false);
  };

  useEffect(() => {
    if (Object.keys(secureKey).length > 0) {
      if (secureKey.Errors) {
        const sessionLang = sessionStorage.getItem('language');

        if (sessionLang === 'en-CA' || sessionLang === 'fr-CA') {
            i18n.changeLanguage(sessionLang);
            updateLanguage({ language: (sessionLang === 'en-CA' || sessionLang === 'en-US') ? "ENG" : "FRA" });
        }
        
        const browserLang = navigator.language || navigator.userLanguage;
        
        if (sessionLang === null) {
            i18n.changeLanguage((browserLang === 'en-US' || browserLang === 'en-CA') ? "en-CA" : "fr-CA");
            updateLanguage({ language: (browserLang === 'en-CA' || browserLang === 'en-US') ? "ENG" : "FRA" });
        }

        setAuthenticationError(true);

        setError(true);

      } else {
        const value = {
          selectedRequest: i18n.t(rk.REQUEST_SELECTOR.ACCESS_INFO),
        };
        const stateReducerValue = {
          currentStateResidence: "QC",
          submissionOnBehalfOf: i18n.t(rk.ON_BEHALF_OPTION_SELF)
        };
        const lang = secureKey?.comSecurekeyVerifiedMeUiLocale;
        loadRequestSelectorSuccess(value);
        loadStateSelectorSuccess(stateReducerValue);
        i18n.changeLanguage(lang);
        updateLanguage({ language: lang === 'en-CA' ? "ENG" : "FRA" });

        history.push({
          pathname: '/mailingAddress'
        });
      }
    }
  }, [history, loadRequestSelectorSuccess, loadStateSelectorSuccess, secureKey, updateLanguage]);

  useEffect(() => {
    if (Object.keys(networkErrorState).length > 0) {
      if (networkErrorState.error) {
        setNetworkError(true);
        setError(true);
      }
    }
  }, [networkErrorState]);

  return (
    <>
      {authenticationError && (
        <section
          id="js-notifications-group"
          className="c-notifications-group  js-panelgroup"
        >
          <div className="c-notification__container  js-notification-container">
            <div className="c-notification  c-notification--error">
              <div className="c-notification__outer-wrap">
                <div className="c-notification__inner-wrap">
                  <i
                    className="c-notification__status-icon"
                    aria-hidden="true"
                    role="img"
                  ></i>

                  <div className="c-notification__content">
                    <p className="c-notification__title">
                      {i18n.t(rk.SECURE_KEY.AUTHENTICATION_ERROR_TITLE)}
                    </p>

                    <p className="c-notification__text c-status-message u-text-white">
                      {i18n.t(rk.SECURE_KEY.AUTHENTICATION_ERROR_DESCRIPTION)}
                    </p>
                  </div>
                  <button
                    type="button"
                    title="Close"
                    className="js-notification-close  c-notification__close"
                    onClick={handleClose}
                  >
                    <span className="u-visually-hidden">Close</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {networkError && (
        <section
          id="js-notifications-group"
          className="c-notifications-group  js-panelgroup"
        >
          <div className="c-notification__container  js-notification-container">
            <div className="c-notification  c-notification--error">
              <div className="c-notification__outer-wrap">
                <div className="c-notification__inner-wrap">
                  <i
                    className="c-notification__status-icon"
                    aria-hidden="true"
                    role="img"
                  ></i>

                  <div className="c-notification__content">
                    <p className="c-notification__title">
                      {i18n.t(rk.SECURE_KEY.NETWORK_ERROR_TITLE)}
                    </p>

                    <p className="c-notification__text c-status-message u-text-white">
                      {i18n.t(rk.SECURE_KEY.NETWORK_ERROR_DESCRIPTION)}
                    </p>
                  </div>
                  <button
                    type="button"
                    title="Close"
                    className="js-notification-close  c-notification__close"
                    onClick={handleClose}
                  >
                    <span className="u-visually-hidden">Close</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
      )}
      {(error) && (
        <div className="footer">
          <p className="footer-text u-mb-large u-mt">
            {i18n.t(rk.SECURE_KEY.FOOTER)}
          </p>
          <div className="footer-container">
            <div className="o-media u-mr-xlarge">
              <div className="o-media__img">
                <i
                  className="c-btn__icon c-icon c-icon--[phone] c-icon--xxlarge phone-icon"
                  aria-hidden="true"
                  role="img"
                ></i>
              </div>
              <div className="o-media__body">
                <p className="phone-text u-mb-none">
                  {i18n.t(rk.SECURE_KEY.PHONE_NUMBER_1)}
                </p>
                <p className="phone-description">
                  {i18n.t(rk.SECURE_KEY.PHONE_NUMBER_DESCRIPTION)}
                </p>
              </div>
            </div>

            <div className="o-media u-mr-xlarge">
              <div className="o-media__img">
                <i
                  className="c-btn__icon c-icon c-icon--[phone] c-icon--xxlarge phone-icon"
                  aria-hidden="true"
                  role="img"
                ></i>
              </div>
              <div className="o-media__body">
                <p className="phone-text u-mb-none">
                  {i18n.t(rk.SECURE_KEY.PHONE_NUMBER_2)}
                </p>
                <p className="phone-description">
                  {i18n.t(rk.SECURE_KEY.PHONE_NUMBER_DESCRIPTION)}
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Callback.propTypes = {
  getUserInfo: PropTypes.func.isRequired,
  loadRequestSelectorSuccess: PropTypes.func.isRequired,
  loadStateSelectorSuccess: PropTypes.func.isRequired,
  updateLanguage: PropTypes.func.isRequired,
  secureKey: PropTypes.object.isRequired,
  networkErrorState: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  secureKey: state.secureKey,
  networkErrorState: state.networkError,
});

const mapDispatchToProps = (dispatch) => ({
  getUserInfo: (action, routeProps, submitPrivacyRequestPayload) =>
    dispatch(getUserInfo(action, routeProps, submitPrivacyRequestPayload)),
  loadRequestSelectorSuccess: (value) => dispatch(loadRequestSelectorSuccess(value)),
  loadStateSelectorSuccess: (value) => dispatch(loadStateSelectorSuccess(value)),
  updateLanguage: (values) => dispatch({ type: "UPDATE_LANGUAGE", payload: values }),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Callback));
